<div class="cosmos-filter">
  <div>
    <button
      [matMenuTriggerFor]="filter"
      mat-button
      class="cosmos-filter__field"
    >
      <div class="cosmos-filter__field__wrapper">
        <span>{{ _filterFieldContentSubject | async }}</span>
        <mat-icon>
          <span>arrow_drop_down</span>
        </mat-icon>
      </div>
    </button>
    <mat-menu
      #filter="matMenu"
      class="cosmos-filter__menu"
    >
      <button
        *ngFor="let option of _filterConfig.filterOptions"
        (click)="onFilterChange(option)"
        mat-menu-item
      >
        <span class="cosmos-filter__menu__text">{{ option }}</span>
      </button>
    </mat-menu>
  </div>
</div>
